import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FileExcelOutlined, FileDoneOutlined } from '@ant-design/icons'
import { useTranslation } from '@zauberware/react-i18n/web'
import { Button, Space, Checkbox, Typography } from 'antd'

const { Text } = Typography

const ExportTab = ({
  onExport = null,
  onExportWithCheckbox = null,
  loading = false,
  translationNamespace,
  showMarkAsShipped = false,
  title = null
}) => {
  const { t } = useTranslation(translationNamespace)
  const [markAsShipped, setMarkAsShipped] = useState(false)

  const handleExport = format => {
    if (onExportWithCheckbox) {
      onExportWithCheckbox(format, markAsShipped)
    } else {
      onExport(format)
    }
  }

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      {(title || showMarkAsShipped) && (
        <Space direction="vertical" size="small">
          {title && <Text strong>{title}</Text>}
          {showMarkAsShipped && (
            <Checkbox checked={markAsShipped} onChange={e => setMarkAsShipped(e.target.checked)}>
              {t('export.markAsShipped', {
                defaultValue: 'Mark exported orders as shipped'
              })}
            </Checkbox>
          )}
        </Space>
      )}
      <Space wrap size="middle">
        <Button icon={<FileExcelOutlined />} onClick={() => handleExport('xlsx')} loading={loading}>
          {t('common:export.excel')}
        </Button>
        <Button icon={<FileDoneOutlined />} onClick={() => handleExport('csv')} loading={loading}>
          {t('common:export.csv')}
        </Button>
      </Space>
    </Space>
  )
}

ExportTab.propTypes = {
  onExport: PropTypes.func,
  onExportWithCheckbox: PropTypes.func,
  loading: PropTypes.bool,
  translationNamespace: PropTypes.string.isRequired,
  showMarkAsShipped: PropTypes.bool,
  title: PropTypes.string
}

export default ExportTab
